import { useTranslation } from 'react-i18next'

import { useDate, useTimeZone } from '../../../hooks'
import Text from '../../Text'

import { getBirdviewRelativeTimeInfo } from './BirdviewRowRelativeTime.utils'

function BirdviewRowRelativeTime({ date }) {
  const { t } = useTranslation()

  const now = useDate()
  const timeZone = useTimeZone()

  const info = date
    ? getBirdviewRelativeTimeInfo({ date, now, timeZone })
    : null

  return info ? (
    <Text isSecondary>{t(info.key, { count: info.count })}</Text>
  ) : null
}

export default BirdviewRowRelativeTime
